import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export function AddItemTrigger({ label, onClick, mobile = false }: { label: string; onClick: () => void; mobile?: boolean }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center justify-center gap-2 border-[1.5px] border-dashed border-primary/50 bg-accent font-semibold text-accent-foreground transition-colors hover:bg-accent/70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        mobile ? "h-14 rounded-2xl text-[15.5px]" : "h-[52px] rounded-[14px] text-[15px]",
      )}
    >
      <Plus className="h-[17px] w-[17px]" aria-hidden="true" />
      {label}
    </button>
  );
}
